var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E20000",
    d: "m8.784 7.448-4.526 5.16a.675.675 0 0 1-1.042 0 .926.926 0 0 1 0-1.189L7.22 6.854 3.216 2.289a.926.926 0 0 1 0-1.189.675.675 0 0 1 1.042 0l4.526 5.16A.9.9 0 0 1 9 6.854c0 .215-.072.43-.216.594"
  })));
};
export default SvgArrowRight;